<template>

  <a-row type="flex" v-if="employee.post_investment[0]">
    <a-col class="team_employee" v-for="(item, index) in employee.post_investment"
           v-on:mouseover="employee.post_investment[index].active = true"
           v-on:mouseleave="employee.post_investment[index].active = false"
           :key="index">
      <img :src="item.picture" class="image">
      <h1 class="team_employee_name" v-if="employee.post_investment[index].active">
        {{ employee.post_investment[index].name_en }}</h1>

    </a-col>
  </a-row>

</template>

<script>
import axios from "axios";
import {reactive, onMounted} from 'vue'

export default {
  name: 'Team_post_investment_en_m',
  setup() {
    let employee = reactive({
      post_investment: [],
    })

    onMounted(() => {
      axios.get('https://sig-china.com:8081/api/employee/post_investment')
          .then((res) => {
            for (let i = 0; i < res.data.length; i++) {
              employee.post_investment.push(res.data[i])
            }
            employee.post_investment.sort((a, b) => {
              return a['id'] - b['id']
            })
            for (let i = 0; i < employee.post_investment.length; i++) {
              employee.post_investment[i]['picture'] = 'https://sig-china.com' + employee.post_investment[i]['picture']
              employee.post_investment[i].active = false
            }
          })
    })

    return {employee}
  }
}
</script>

<style scoped>
.team_employee {
  width: 50vw;
  align-items: center;
  justify-content: center;
  position: relative;
}

.image {
  width: 50vw;

}

.team_employee_name {
  z-index: 2;
  position: absolute;
  bottom: 3vh;
  left: 2vw;
}

.image:hover {
  opacity: 0.5;
}
</style>
